import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getToolOptionChoiceDescriptionI18nKey, getToolOptionChoiceTitleI18nKey } from 'src/_shared/utils/getI18nKeys';
import { ProductOptionChoiceDetailsInstance, ProductOptionChoiceDetailsModel } from './productOptionChoiceDetails';

export type TProductOptionChoice = typeof ProductOptionChoiceModel;
export type ProductOptionChoiceInstance = Instance<TProductOptionChoice>;
export interface IProductOptionChoiceIn extends SnapshotIn<TProductOptionChoice> {}
export interface IProductOptionChoiceInstance extends ProductOptionChoiceInstance {}
export type TProductOptionChoiceConfigurationIdsMap = ProductOptionChoiceInstance['productConfigurationIdsMap'];

export const ProductOptionChoiceModel = types
  .model({
    productOptionChoiceCode: types.identifier,
    productFamily: types.string,
    productOptionCode: types.string,
    previewImageUrl: types.maybe(types.string),
    productConfigurationIdsMap: types.map(types.string), // map shaped like { [productId]: productConfigurationId }
    selected: types.boolean,
    hint: types.maybe(types.string),
    enabled: types.boolean,
    price: types.maybe(types.number),
    referencingOtherGroupCode: types.maybe(types.string),
    choiceDetails: types.maybe(ProductOptionChoiceDetailsModel),
    isCustom: types.boolean,
  })
  .volatile<{
    isSuboptimal: boolean;
  }>(self => ({
    isSuboptimal: false,
  }))
  .views(self => ({
    get titleKey() {
      return getToolOptionChoiceTitleI18nKey(
        self.productFamily,
        self.productOptionCode,
        self.productOptionChoiceCode,
        self.choiceDetails,
      );
    },
    get descriptionKey() {
      return getToolOptionChoiceDescriptionI18nKey(
        self.productFamily,
        self.productOptionCode,
        self.productOptionChoiceCode,
      );
    },
  }))
  .actions(self => ({
    updateSelected(selected: boolean, choiceDetails?: ProductOptionChoiceDetailsInstance) {
      self.selected = selected;
      self.choiceDetails = choiceDetails;
    },
    setIsSuboptimal(isSuboptimal: boolean) {
      self.isSuboptimal = isSuboptimal;
    },
  }));
